"use strict";

var _interopRequireDefault = require("E:/zkdn_workspace/zhijiao/bjzyjy-mhwz/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _mixinPanel = _interopRequireDefault(require("@/libs/flowable/common/mixinPanel"));
var _parseElement = require("@/libs/flowable/common/parseElement");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  mixins: [_mixinPanel.default],
  data: function data() {
    return {
      dialogVisible: true,
      formData: {}
    };
  },
  computed: {
    formConfig: function formConfig() {
      var _this = this;
      return {
        inline: false,
        item: [{
          xType: 'input',
          name: 'collection',
          label: '集合',
          tooltip: '属性会作为表达式进行解析。如果表达式解析为字符串而不是一个集合，<br />不论是因为本身配置的就是静态字符串值，还是表达式计算结果为字符串，<br />这个字符串都会被当做变量名，并从流程变量中用于获取实际的集合。'
        }, {
          xType: 'input',
          name: 'elementVariable',
          label: '元素变量',
          tooltip: '每创建一个用户任务前，先以该元素变量为label，集合中的一项为value，<br />创建（局部）流程变量，该局部流程变量被用于指派用户任务。<br />一般来说，该字符串应与指定人员变量相同。'
        }, {
          xType: 'radio',
          name: 'isSequential',
          label: '执行方式',
          dic: [{
            label: '串行',
            value: true
          }, {
            label: '并行',
            value: false
          }]
        }, {
          xType: 'input',
          name: 'completionCondition',
          label: '完成条件',
          tooltip: '多实例活动在所有实例都完成时结束，然而也可以指定一个表达式，在每个实例<br />结束时进行计算。当表达式计算为true时，将销毁所有剩余的实例，并结束多实例<br />活动，继续执行流程。例如 ${nrOfCompletedInstances/nrOfInstances >= 0.6 }，<br />表示当任务完成60%时，该节点就算完成'
        }],
        operate: [{
          text: '确定',
          show: true,
          click: _this.save
        }, {
          text: '清空',
          show: true,
          click: function click() {
            _this.formData = {};
          }
        }]
      };
    }
  },
  mounted: function mounted() {
    var obj = this.element.businessObject.loopCharacteristics;
    var cache = JSON.parse(JSON.stringify(obj != null ? obj : {}));
    cache.completionCondition = cache.completionCondition.body;
    this.formData = (0, _parseElement.formatJsonKeyValue)(cache);
  },
  methods: {
    updateElement: function updateElement() {
      if (this.formData.isSequential !== null && this.formData.isSequential !== undefined) {
        var loopCharacteristics = this.element.businessObject.get('loopCharacteristics');
        if (!loopCharacteristics) {
          loopCharacteristics = this.modeler.get('moddle').create('bpmn:MultiInstanceLoopCharacteristics');
        }
        loopCharacteristics['isSequential'] = this.formData.isSequential;
        loopCharacteristics['collection'] = this.formData.collection;
        loopCharacteristics['elementVariable'] = this.formData.elementVariable;
        if (this.formData.completionCondition) {
          var completionCondition = this.modeler.get('moddle').create('bpmn:Expression', {
            body: this.formData.completionCondition
          });
          loopCharacteristics['completionCondition'] = completionCondition;
        }
        this.updateProperties({
          loopCharacteristics: loopCharacteristics
        });
      } else {
        delete this.element.businessObject.loopCharacteristics;
      }
    },
    save: function save() {
      this.updateElement();
      this.dialogVisible = false;
    }
  }
};